module.exports = __webpack_public_path__ + "img/57.8552383a.jpg";